import { createFileRoute } from "@tanstack/react-router";
import OptionSetPage from "lib/components/options/catalog/edit/OptionSetPage";
import { useAppRouterParams } from "lib/routeHelpers";
import withAuthentication from "../../../../../components/withAuthentication";

function OptionSet() {
  const { builderId } = useAppRouterParams();
  if (!builderId) {
    return null;
  }
  return <OptionSetPage builderId={builderId} />;
}

export const Route = createFileRoute("/builders/$builder_id/options/edit/set")({
  component: withAuthentication(OptionSet, {
    permissions: ["VIEW_OPTION_CATALOG", "EDIT_OPTION_CATALOG"],
    permissionOperator: "AND",
    features: ["nextGenOptions"],
  }),
});
